import _ from 'lodash';

const isArrayDeepEqual = (array1: any[], array2: any[]) => {
    return _(array1).xorWith(array2, _.isEqual).isEmpty();
};

export const ArrayUtil = {
    isArrayDeepEqual
}
